import { render, staticRenderFns } from "./PassportView.vue?vue&type=template&id=28164240&scoped=true"
import script from "./PassportView.vue?vue&type=script&lang=js"
export * from "./PassportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28164240",
  null
  
)

export default component.exports